import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { useButtonVisitedMutation, useDeletePostMutation, useDownVotePostMutation, useSharePostMutation, useUpVotePostMutation, useViewPostQuery } from "../../API/postAPI";
import { useFavouritePostMutation, useUnFavouritePostMutation } from "../../API/trailAPI";
import { Loader } from "../../components/Loader";
import Video from "../../components/Video";
import { addTagModal, logInModal, cliamBusinessModal, yourTrailsModal, shareModal, updatesModal } from "../../redux/modalSlice";
import NoFoundComponent from "../NoFoundComponent";
import videojs from "video.js";
import { useState } from "react";
import { toast } from "react-toastify";
import { config } from "../../config";
import { useGetAnalyticsQuery } from "../../API/analyticsAPI";
import { AES, enc } from "crypto-js";
import { MetaData } from "../../components/MetaData";

export const PostDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: postDetails, isLoading, isSuccess, isError, error } = useViewPostQuery(id);
  const showTags = postDetails && postDetails.data && postDetails.data.status && postDetails.data.status !== "Approved" ? true : false;

  const [favourite, setFavourite] = useState(0);

  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};

  // console.log("user :: ", user);

  const [favouritePost, { data: favouritePostData, isLoading: favouritePostIsLoading, isSuccess: favouritePostIsSuccess, isError: favouritePostIsError, error: favouritePostError }] = useFavouritePostMutation();
  const [unFavouritePost, { data: unFavouritePostData, isLoading: unFavouritePostIsLoading, isSuccess: unFavouritePostIsSuccess, isError: unFavouritePostIsError, error: unFavouritePostError }] = useUnFavouritePostMutation();
  useEffect(() => {
    setFavourite(postDetails?.data?.favorite);
  }, [postDetails]);
  const [deletePost, { data: deletePostData, isLoading: deletePostIsLoading, isSuccess: deletePostIsSuccess, isError: deletePostIsError, error: deletePostError }] = useDeletePostMutation();
  const [sharePost, { data: sharePosts, isLoading: sharePostIsLoading, isSuccess: sharePostIsSuccess, isError: sharePostIsError, error: sharePostError }] = useSharePostMutation();
  const [upVotePost, { data: upVotePostTagData, isLoading: upVotePostTagIsLoading, isSuccess: upVotePostTagIsSuccess, isError: upVotePostTagIsError, error: upVotePostTagError }] = useUpVotePostMutation();
  const [downVotePost, { data: downVoteData, isLoading: downVoteIsLoading, isSuccess: downVoteIsSuccess, isError: downVoteIsError, error: downVoteError }] = useDownVotePostMutation();

  const playerRef1 = React.useRef(null);

  const handlePlayerReady = (player) => {
    playerRef1.current = player;

    // You can handle player events here, for example:
    player.on("waiting", () => {
      videojs.log("player is waiting");
    });

    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };
  useEffect(() => {
    if (deletePostIsSuccess) {
      if (deletePostData.status === 200) {
        toast(deletePostData.message, {
          ...config.toast_config,
          type: "success",
        });
        navigate("/place");
      } else {
        toast(deletePostData.message, {
          ...config.toast_config,
          type: "error",
        });
      }
    }
  }, [deletePostIsSuccess]);

  //Set Anlaytics Data::start
  const { data: analyticalData, isLoading: analyticalDataIsLoading, isSuccess: analyticalDataIsSuccess, isError: analyticalDataIsError, error: analyticalDataError } = useGetAnalyticsQuery(id);
  const [postAnalytics, setPostAnalytics] = useState([]);
  useEffect(() => {
    let anaData = [];
    if (analyticalData && analyticalData.status === 200 && analyticalData.data && analyticalData.data.top3Tag && analyticalData.data.top3Tag.length) {
      analyticalData.data.top3Tag.forEach((tag, index) => {
        if (tag.post_id == postDetails?.data?.id) {
          if (tag.tag_vote && tag.tag_vote.length) {
            anaData = tag.tag_vote;
          }
        }
      });
    }

    if (anaData && anaData.length) setPostAnalytics(anaData);
  }, [analyticalData, analyticalDataIsSuccess]);

  const handleShareButtonClick = (postId) => {
    if (token && token !== undefined && token !== "") {
      sharePost({ post_id: postId });
      dispatch(
        shareModal({
          modal: true,
          postId: postDetails?.data?.id,
          shareLink: postDetails?.data?.share_link,
        })
      );
    } else {
      dispatch(logInModal(true));
    }
  };

  const [buttonVisited, { data: buttonVisiteds, isLoading: buttonVisitedIsLoading, isSuccess: buttonVisitedIsSuccess, isError: buttonVisitedIsError, error: buttonVisitedError }] = useButtonVisitedMutation();

  //Set Anlaytics Data::end

  //post update modal :start
  const [updates, setUpdates] = useState("");
  useEffect(() => {
    setUpdates(postDetails?.data?.updates);
  }, [postDetails]);

  //post update modal :end

  //post tag vote feature ::start
  const [tagArray, setTagArray] = useState([]);
  const updateTagStats = (data) => {
    let { postId, tag } = data;
    const tmpTagArray = tagArray.map((tagI) => {
      if (tagI.tag_name === tag) {
        return tagI.user_vote ? { ...tagI, count: tagI.count - 1, user_vote: !tagI.user_vote } : { ...tagI, count: tagI.count + 1, user_vote: !tagI.user_vote }; // Using object spread syntax to update the 'count' value
      }
      return tagI;
    });
    setTagArray(tmpTagArray);
  };
  const handleTagVote = (postId) => {
    console.log("postId :: ", postId);
    updateTagStats(postId);
    if (postId.user_vote) {
      dispatch(downVotePost({ post_id: postId.postId, tag: postId.tag }));
    } else {
      dispatch(upVotePost({ post_id: postId.postId, tag: postId.tag }));
    }
  };
  useEffect(() => {
    setTagArray(showTags ? postDetails?.data?.tags : postDetails?.data?.tagstats);

    return () => { };
  }, [postDetails]);

  //post tag vote feature ::end

  //set Daynamic title in html page. ::start
  useEffect(() => {
    const dynamicTitle = postDetails?.data?.post_name + "- Thruhike";
    // Set the document title when the component mounts
    document.title = dynamicTitle;

    // Optionally, you can reset the document title when the component unmounts
    return () => {
      document.title = "Thruhike";
    };
  }, [postDetails]);
  //set Daynamic title in html page. ::end

  if (isLoading) {
    return <Loader />;
  } else {
    // if (token !== null && token !== "" && token !== undefined) {
    return (
      <>
        <MetaData pageTitle={postDetails?.data?.post_name ? postDetails?.data?.post_name + "- Thruhike" : "Thruhike"} metaTitle={postDetails?.data?.meta_title ? postDetails?.data?.meta_title : ""} metaDescription={postDetails?.data?.meta_description ? postDetails?.data?.meta_description : "Thruhike"} metaKeywords={postDetails?.data?.meta_keyword ? postDetails?.data?.meta_keyword : "Thruhike"} />
        <div className="container">
          <div className="trail_detail d-flex justify-content-between">
            <div className="trail_post_user ">
              <div className="d-flex justify-content-between">
                <h4 className="w-auto">
                  <Link to="#" style={{ fontSize: "20px" }}>
                    {postDetails?.data?.post_name}
                  </Link>
                </h4>
                <div className="trail_tag_like">
                  <Link
                    to="#"
                    className="social_icon"
                    onClick={() =>
                      token && token !== undefined && token !== ""
                        ? dispatch(
                          addTagModal({
                            modal: true,
                            postId: postDetails?.data?.id,
                          })
                        )
                        : dispatch(logInModal(true))
                    }
                  >
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M4.50827 17.5L5.09993 14.1667H1.7666L2.05827 12.5H5.3916L6.27494 7.5H2.9416L3.23327 5.83333H6.5666L7.15827 2.5H8.82493L8.23327 5.83333H13.2333L13.8249 2.5H15.4916L14.8999 5.83333H18.2333L17.9416 7.5H14.6083L13.7249 12.5H17.0583L16.7666 14.1667H13.4333L12.8416 17.5H11.1749L11.7666 14.1667H6.7666L6.17493 17.5H4.50827ZM7.9416 7.5L7.05827 12.5H12.0583L12.9416 7.5H7.9416Z" fill="#66737F" />
                      </svg>
                      Add your #tag
                    </span>
                  </Link>
                  <Link
                    to="#"
                    className="social_icon"
                    onClick={() => {
                      if (token && token !== undefined && token !== "") {
                        if (favourite) {
                          unFavouritePost({ post_id: postDetails?.data?.id });
                          setFavourite(false);
                        } else {
                          favouritePost({ post_id: postDetails?.data?.id });
                          setFavourite(true);
                        }
                      } else {
                        dispatch(logInModal(true));
                      }
                    }}
                  >
                    <span>
                      {favourite ? (
                        <svg width="20" height="20" style={{ marginTop: -6 }} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.00008 15.7917L7.79175 14.6917C3.50008 10.8 0.666748 8.225 0.666748 5.08333C0.666748 2.50833 2.68341 0.5 5.25008 0.5C6.70008 0.5 8.09175 1.175 9.00008 2.23333C9.90841 1.175 11.3001 0.5 12.7501 0.5C15.3167 0.5 17.3334 2.50833 17.3334 5.08333C17.3334 8.225 14.5001 10.8 10.2084 14.6917L9.00008 15.7917Z" fill="#FE4954" />
                        </svg>
                      ) : (
                        <svg width="20" height="20" style={{ marginTop: -6 }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.0834 15.4583L10.0001 15.5417L9.90841 15.4583C5.95008 11.8667 3.33341 9.49167 3.33341 7.08333C3.33341 5.41667 4.58341 4.16667 6.25008 4.16667C7.53341 4.16667 8.78341 5 9.22508 6.13333H10.7751C11.2167 5 12.4667 4.16667 13.7501 4.16667C15.4167 4.16667 16.6667 5.41667 16.6667 7.08333C16.6667 9.49167 14.0501 11.8667 10.0834 15.4583ZM13.7501 2.5C12.3001 2.5 10.9084 3.175 10.0001 4.23333C9.09175 3.175 7.70008 2.5 6.25008 2.5C3.68341 2.5 1.66675 4.50833 1.66675 7.08333C1.66675 10.225 4.50008 12.8 8.79175 16.6917L10.0001 17.7917L11.2084 16.6917C15.5001 12.8 18.3334 10.225 18.3334 7.08333C18.3334 4.50833 16.3167 2.5 13.7501 2.5Z"
                            fill="#66737F"
                          />
                        </svg>
                      )}
                      Favorite
                    </span>
                  </Link>
                  <Link
                    to="#"
                    className="social_icon"
                    onClick={() =>
                      token && token !== undefined && token !== ""
                        ? dispatch(
                          yourTrailsModal({
                            modal: true,
                            postId: postDetails?.data?.id,
                          })
                        )
                        : dispatch(logInModal(true))
                    }
                  >
                    <span>
                      {/* <img
                        src={require("../../assets/images/trails.svg")}
                        alt=""
                        title=""
                        height="18"
                      /> */}
                      {/* <img src={require("../assets/images/trail.svg")} alt="" title="" /> */}
                      <svg width="20" height="20" style={{ marginTop: -6 }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.0833 3.33333C11.1666 3.41667 11.1666 3.41667 11.1666 4C11.1666 4.25 11.1666 4.5 11.1666 4.58333C11.1666 4.58333 11.4999 4.58333 13.4166 4.66667H15.5833L16.0833 5.25C16.4999 5.58333 16.6666 5.83333 16.6666 5.83333C16.6666 5.83333 16.4999 6.08333 16.1666 6.5L15.6666 7.08333H13.4999C11.5833 7.08333 11.2499 7.08333 11.2499 7.16667C11.2499 7.16667 11.2499 7.58333 11.2499 8.16667C11.2499 9 11.2499 9.08333 11.2499 9.16667C11.2499 9.16667 11.3333 9.25 11.9166 9.25H12.5833L12.6666 9.16667C12.7499 9.25 12.7499 9.25 12.7499 10.3333C12.7499 11.0833 12.7499 11.5 12.7499 11.5C12.5833 11.6667 12.5833 11.6667 11.8333 11.6667C11.3333 11.6667 11.1666 11.6667 11.1666 11.6667C11.1666 11.6667 11.1666 12.25 11.1666 14.0833V16.5L11.0833 16.5833V16.6667H9.99995H8.99995L8.91661 16.5833L8.83328 16.5V14.1667C8.83328 12.3333 8.83328 11.75 8.83328 11.75C8.83328 11.75 8.24995 11.75 6.58328 11.75H4.41661L3.91661 11.1667C3.58328 10.75 3.33328 10.5 3.33328 10.4167V10.3333C3.33328 10.3333 3.58328 10 3.83328 9.66667L4.33328 9.08333H6.49995C8.49995 9.08333 8.66661 9.08333 8.74995 9.08333C8.83328 9.08333 8.83328 9 8.83328 8.08333C8.83328 7.25 8.83328 7.16667 8.83328 7.08333C8.83328 7.08333 8.66661 7.08333 8.16661 7.08333C7.58328 7.08333 7.49995 7.08333 7.41661 7H7.33328V5.83333V4.66667L7.41661 4.58333L7.49995 4.5H8.16661C8.74995 4.5 8.83328 4.5 8.83328 4.5C8.83328 4.5 8.83328 4.41667 8.83328 3.91667C8.83328 3.41667 8.83328 3.41667 8.91661 3.33333H8.99995H9.99995H11.0833ZM11.7499 1.66667H11.0833H9.99995H8.99995H8.24995L7.74995 2.16667V2.25C7.49995 2.41667 7.33328 2.66667 7.33328 2.91667H6.74995L6.24995 3.33333V3.41667L6.16661 3.5L5.66661 4V4.66667V5.83333V7V7.5H4.33328H3.58328L3.08328 8L2.58328 8.58333C1.99995 9.25 1.83328 9.41667 1.74995 9.66667C1.58328 10.1667 1.58328 10.6667 1.83328 11.1667C1.91661 11.3333 1.91661 11.4167 2.58328 12.1667L3.08328 12.75L3.66661 13.3333H4.41661H6.58328C6.74995 13.3333 6.91661 13.3333 7.16661 13.3333C7.16661 13.6667 7.16661 13.9167 7.16661 14.1667V16.5833V17.25L7.66661 17.75L7.74995 17.8333L7.83328 17.9167L8.24995 18.3333H8.91661H9.99995H11.0833H11.7499L12.2499 17.8333L12.3333 17.75L12.4166 17.6667L12.9166 17.1667V16.5V14.1667C12.9166 13.9167 12.9166 13.6667 12.9166 13.3333C13.4166 13.25 13.9166 13 14.2499 12.3333C14.4166 11.9167 14.4166 11.6667 14.4166 10.5C14.4166 9.66667 14.4166 9.16667 14.3333 8.91667H15.7499H16.4999L16.9999 8.33333L17.4999 7.75C17.9999 6.91667 18.3333 6.5 18.3333 5.83333C18.3333 5.16667 17.9999 4.75 17.4166 4.08333L16.9166 3.5L16.4166 2.91667H15.6666H13.4999C13.2499 2.91667 12.9999 2.91667 12.7499 2.91667C12.6666 2.66667 12.4999 2.41667 12.3333 2.25L12.2499 2.16667L11.7499 1.66667Z"
                          fill="#66737F"
                        />
                      </svg>
                      Add to trail
                    </span>
                  </Link>
                  <Link
                    to="#"
                    onClick={() => handleShareButtonClick(postDetails?.data?.id)}
                    // data-bs-toggle="modal"
                    // data-bs-target="#sharepost"
                    className="social_icon"
                  >
                    <span>
                      {/* <img
                        src={require("../../assets/images/share.svg")}
                        alt=""
                        title=""
                      /> */}
                      <svg width="20" height="20" style={{ marginTop: -6 }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.81818 2.00002L6.90909 4.90911H9.09091V11.4546H10.5455V4.90911H12.7273M14.1818 18H5.45455C4.64727 18 4 17.3455 4 16.5455V7.8182C4 7.43243 4.15325 7.06246 4.42603 6.78968C4.69881 6.5169 5.06878 6.36366 5.45455 6.36366H7.63636V7.8182H5.45455V16.5455H14.1818V7.8182H12V6.36366H14.1818C14.5676 6.36366 14.9376 6.5169 15.2103 6.78968C15.4831 7.06246 15.6364 7.43243 15.6364 7.8182V16.5455C15.6364 16.9312 15.4831 17.3012 15.2103 17.574C14.9376 17.8468 14.5676 18 14.1818 18Z"
                          fill="#66737F"
                        />
                      </svg>
                      Share
                    </span>
                  </Link>
                  {postDetails?.data?.user_id === user?.id && postDetails?.data?.status !== "Pending" ? (
                    <>
                      <Link
                        to="/addplace"
                        className="social_icon"
                        onClick={() => {
                          localStorage.setItem("editPost", JSON.stringify(postDetails?.data));
                        }}
                      >
                        <span>
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.71667 5.5L10.5 6.28333L2.93333 13.8333H2.16667V13.0667L9.71667 5.5ZM12.7167 0.5C12.5083 0.5 12.2917 0.583333 12.1333 0.741667L10.6083 2.26667L13.7333 5.39167L15.2583 3.86667C15.5833 3.54167 15.5833 3 15.2583 2.69167L13.3083 0.741667C13.1417 0.575 12.9333 0.5 12.7167 0.5ZM9.71667 3.15833L0.5 12.375V15.5H3.625L12.8417 6.28333L9.71667 3.15833Z" fill="#66737f"></path>
                          </svg>
                          &nbsp; Edit
                        </span>
                      </Link>
                      <Link
                        to="#"
                        className="social_icon"
                        onClick={() => {
                          if (window.confirm("Are you sure you want to delete this place?")) {
                            deletePost(postDetails?.data?.id);
                          } else {
                            // do not delete the item
                          }
                        }}
                      >
                        <span>
                          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.49967 0.5V1.33333H0.333008V3H1.16634V13.8333C1.16634 14.2754 1.34194 14.6993 1.6545 15.0118C1.96706 15.3244 2.39098 15.5 2.83301 15.5H11.1663C11.6084 15.5 12.0323 15.3244 12.3449 15.0118C12.6574 14.6993 12.833 14.2754 12.833 13.8333V3H13.6663V1.33333H9.49967V0.5H4.49967ZM2.83301 3H11.1663V13.8333H2.83301V3ZM4.49967 4.66667V12.1667H6.16634V4.66667H4.49967ZM7.83301 4.66667V12.1667H9.49967V4.66667H7.83301Z" fill="#DD1010"></path>
                          </svg>
                          &nbsp; Delete
                        </span>
                      </Link>
                    </>
                  ) : (
                    ""
                  )}

                  {/* <ul className="d-inline-flex navbar-nav">
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        className="social_icon dropdown-toggle"
                      >
                        <span>
                          <img
                            src={require("../../assets/images/tagmenu.png")}
                            alt=""
                            title=""
                            className="m-0"
                            style={{ verticalAlign: "baseline" }}
                          />
                        </span>
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <Link className="dropdown-item" to="#">
                            {postDetails?.data?.favorite ? (
                              <i
                                className="fas fa-heart"
                                style={{
                                  fontSize: "18px",
                                  color: "rgb(254, 73, 84)",
                                  //   alignItems: "center",
                                  //   display: "flex",
                                  //   justifyContent: "space-between",
                                }}
                              ></i>
                            ) : (
                              <>
                                <img
                                  src={require("../../assets/images/favriout.png")}
                                  alt="favourite-icon"
                                  title=""
                                />
                                <span className="favriout_hover">
                                  Added in your Favorite Trail
                                  <i className="fas fa-heart"></i>
                                </span>
                              </>
                            )}
                            Favorite
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item"
                            onClick={() =>
                              dispatch(
                                yourTrailsModal({
                                  modal: true,
                                  postId: postDetails?.data?.id,
                                })
                              )
                            }
                          >
                            <svg
                              width="14"
                              height="16"
                              viewBox="0 0 14 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.99967 12.3333C4.05967 12.3333 1.66634 9.93998 1.66634 6.99998C1.66634 4.05998 4.05967 1.66665 6.99967 1.66665C9.93967 1.66665 12.333 4.05998 12.333 6.99998C12.333 9.93998 9.93967 12.3333 6.99967 12.3333ZM6.99967 0.333313C6.1242 0.333313 5.25729 0.505751 4.44845 0.840783C3.63961 1.17581 2.90469 1.66688 2.28563 2.28593C1.03539 3.53618 0.333008 5.23187 0.333008 6.99998C0.333008 8.76809 1.03539 10.4638 2.28563 11.714C2.90469 12.3331 3.63961 12.8241 4.44845 13.1592C5.25729 13.4942 6.1242 13.6666 6.99967 13.6666C8.76779 13.6666 10.4635 12.9643 11.7137 11.714C12.964 10.4638 13.6663 8.76809 13.6663 6.99998C13.6663 6.1245 13.4939 5.25759 13.1589 4.44876C12.8238 3.63992 12.3328 2.90499 11.7137 2.28593C11.0947 1.66688 10.3597 1.17581 9.5509 0.840783C8.74206 0.505751 7.87515 0.333313 6.99967 0.333313ZM7.66634 3.66665H6.33301V6.33331H3.66634V7.66665H6.33301V10.3333H7.66634V7.66665H10.333V6.33331H7.66634V3.66665Z"
                                fill="#66737F"
                              />
                            </svg>
                            Add to Trail
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item"
                            onClick={() =>
                              dispatch(
                                addTagModal({
                                  modal: true,
                                  postId: postDetails?.data?.id,
                                })
                              )
                            }
                          >
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.60642 12L3.07975 9.33333H0.413086L0.646419 8H3.31309L4.01975 4H1.35309L1.58642 2.66667H4.25309L4.72642 0H6.05975L5.58642 2.66667H9.58642L10.0598 0H11.3931L10.9198 2.66667H13.5864L13.3531 4H10.6864L9.97975 8H12.6464L12.4131 9.33333H9.74642L9.27309 12H7.93975L8.41309 9.33333H4.41309L3.93975 12H2.60642ZM5.35309 4L4.64642 8H8.64642L9.35309 4H5.35309Z"
                                fill="#66737F"
                              />
                            </svg>
                            Add your #tag
                          </Link>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="#sharepost"
                            data-bs-toggle="modal"
                            data-bs-target="#sharepost"
                          >
                            <svg
                              width="10"
                              height="18"
                              viewBox="0 0 10 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.85474 0.600006L2.52747 2.92728H4.27292V8.16364H5.43656V2.92728H7.18201M8.34565 13.4H1.36383C0.718013 13.4 0.200195 12.8764 0.200195 12.2364V5.25455C0.200195 4.94594 0.322792 4.64996 0.541016 4.43174C0.759241 4.21351 1.05522 4.09092 1.36383 4.09092H3.10929V5.25455H1.36383V12.2364H8.34565V5.25455H6.60019V4.09092H8.34565C8.65427 4.09092 8.95024 4.21351 9.16846 4.43174C9.38669 4.64996 9.50929 4.94594 9.50929 5.25455V12.2364C9.50929 12.545 9.38669 12.841 9.16846 13.0592C8.95024 13.2774 8.65427 13.4 8.34565 13.4Z"
                                fill="#66737F"
                              />
                            </svg>
                            Share
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul> */}
                </div>
              </div>
              <p className="mb-2">
                {postDetails?.data?.category?.category_name}
                <a href={"https://maps.google.com?q=" + postDetails?.data?.address} target="_blank" className="float-none">
                  <span className="ms-4">
                    <i className="fas fa-map-marker-alt"></i>&nbsp; {postDetails?.data?.address}
                  </span>
                </a>
              </p>
            </div>
          </div>
          {/* <!-- start trail detail images post --> */}
          <div className="detail_images">
            <div className="row">
              <div className="col-lg-6 col-md-9 col-sm-12 ">
                {postDetails?.data?.hasVideo ? (
                  postDetails?.data?.media && postDetails?.data?.media?.length ? (
                    postDetails?.data?.media.map((media, index) =>
                      media.type === 2 ? (
                        <Video
                          key={"media_" + index + media.id}
                          options={{
                            autoplay: false,
                            controls: true,
                            responsive: true,
                            fluid: true,
                            sources: [
                              {
                                src: `${media?.media_name}`,
                                type: "application/x-mpegURL",
                              },
                            ],
                            poster: `${media.thumbnail_img}`,
                          }}
                          onReady={handlePlayerReady}
                        />
                      ) : (
                        ""
                      )
                    )
                  ) : (
                    ""
                  )
                ) : postDetails?.data?.media && postDetails?.data?.media?.length ? (
                  <div className="trail_post_img">
                    <img src={postDetails?.data?.media[0]?.media_name} alt={postDetails?.data?.media?.media_name} title={postDetails?.data?.media?.media_name} key={"media" + postDetails?.data?.media[0].id} />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 side_smallimg">
                <div className="row">
                  {postDetails?.data?.media && postDetails?.data?.media?.length
                    ? postDetails?.data?.media.map((media, index) =>
                      index !== 0 && media.type === 1 ? (
                        <div className="col-lg-6 col-md-6 col-sm-6 responsive_img" key={"media_img_" + index}>
                          <div className="trail_post_img">
                            <img src={media?.media_name} alt={media?.media_name} title={media?.media_name} key={"media" + index + media.id} />
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    )
                    : ""}
                </div>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="tag_list mt-2">
                  {tagArray && tagArray.length ? (
                    tagArray.map((tag, index) => (
                      <Link
                        to="#"
                        className="active"
                        key={"post-details-tag" + tag.id + index}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          // handleModalOpens(5, { postId: post?.id, tag: tag.tag_name, user_vote: tag.user_vote });
                          handleTagVote({ postId: postDetails?.data?.id, tag: tag.tag_name, user_vote: tag?.user_vote });
                        }}
                      >
                        <span className="mx-1">{tag.tag_name}</span>
                        {showTags ? (
                          ""
                        ) : (
                          <>
                            <span className="me-1">
                              {tag.user_vote ? (
                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: "sub" }}>
                                  <g clipPath="url(#clip0_1463_816)">
                                    <g clipPath="url(#clip1_1463_816)">
                                      <path d="M5.21875 17.2287L1 17.2287L0.999999 6.09398L5.21875 6.09398L5.21875 17.2287Z" fill="#008B2A" />
                                      <path
                                        d="M18.2587 9.67634C18.4832 9.9751 18.6165 10.3462 18.6165 10.7478C18.6165 11.3429 18.3238 11.8707 17.8751 12.1956C18.0997 12.4944 18.233 12.8654 18.233 13.2671C18.233 13.8622 17.9407 14.3902 17.492 14.7152C17.7164 15.0139 17.8495 15.3849 17.8495 15.7864C17.8495 16.7717 17.0478 17.5733 16.0625 17.5733L10.4369 17.5733C9.51024 17.5733 8.60054 17.4084 7.73305 17.0831L6.27344 16.5357L6.27344 7.30755C7.98393 5.46701 9.54951 3.71026 9.83146 3.25899L9.83146 1.1848C9.83146 0.766761 10.1715 0.42666 10.5896 0.42666C12.3136 0.42666 13.7162 1.82929 13.7162 3.55332L13.7162 4.48893L13.1509 6.44161L17.213 6.44161C18.1983 6.44161 19 7.24325 19 8.22857C19 8.82366 18.7073 9.35139 18.2587 9.67634Z"
                                        fill="#008B2A"
                                      />
                                    </g>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1463_816">
                                      <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                    <clipPath id="clip1_1463_816">
                                      <rect width="18" height="18" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 1 18)" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              ) : (
                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: "sub" }}>
                                  <g clipPath="url(#clip0_1463_824)">
                                    <g clipPath="url(#clip1_1463_824)">
                                      <path
                                        d="M18.2587 9.67634C18.4832 9.9751 18.6165 10.3462 18.6165 10.7478C18.6165 11.3429 18.3238 11.8707 17.8751 12.1956C18.0997 12.4944 18.233 12.8654 18.233 13.2671C18.233 13.8622 17.9406 14.3902 17.492 14.7152C17.7164 15.0139 17.8494 15.3849 17.8494 15.7864C17.8494 16.7717 17.0478 17.5733 16.0624 17.5733L15.2709 17.5733L10.4369 17.5733C9.51031 17.5733 8.60057 17.4084 7.73306 17.0831L5.97394 16.4234L5.97394 17.2286L1 17.2286L0.999999 6.09395L5.97398 6.09395L5.97398 7.62902C7.79764 5.67559 9.53312 3.73645 9.83146 3.25899L9.83146 1.18477C9.83146 0.766727 10.1715 0.42666 10.5896 0.42666C12.3136 0.42666 13.7162 1.82925 13.7162 3.55332L13.7162 4.48893L13.1509 6.44161L17.213 6.44161C18.1983 6.44161 19 7.24325 19 8.22857C19 8.82362 18.7073 9.35136 18.2587 9.67634ZM4.91929 7.14868L2.05469 7.14868L2.05469 16.174L4.91929 16.174L4.91929 7.14868ZM17.213 7.4963L11.7475 7.4963L12.6615 4.3393L12.6615 3.55332C12.6615 2.51153 11.8886 1.64686 10.8861 1.50251L10.8861 3.36586C10.8861 3.62127 10.8861 3.823 8.29253 6.66981C7.31835 7.73909 6.33468 8.78668 5.97398 9.16953L5.97398 15.297L8.10339 16.0955C8.85211 16.3763 9.63719 16.5187 10.4369 16.5187L15.2709 16.5187L16.0625 16.5187C16.4663 16.5187 16.7948 16.1901 16.7948 15.7864C16.7948 15.3826 16.4663 15.0541 16.0625 15.0541L16.0625 13.9994L16.446 13.9994C16.8498 13.9994 17.1783 13.6709 17.1783 13.2671C17.1783 12.8633 16.8498 12.5348 16.446 12.5348L16.446 11.4801C16.4694 11.4801 16.4925 11.481 16.5156 11.4819L16.5156 11.4801L16.8295 11.4801C17.2333 11.4801 17.5618 11.1516 17.5618 10.7478C17.5618 10.3441 17.2333 10.0156 16.8295 10.0156L16.7638 10.0156L16.7638 8.96088L17.213 8.96088C17.6168 8.96088 17.9453 8.63234 17.9453 8.22857C17.9453 7.82477 17.6168 7.4963 17.213 7.4963Z"
                                        fill="#374149"
                                      />
                                    </g>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1463_824">
                                      <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                    <clipPath id="clip1_1463_824">
                                      <rect width="18" height="18" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 1 18)" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              )}
                            </span>
                            <span>{tag.count > 0 ? `(${tag.count})` : ""}</span>
                          </>
                        )}
                      </Link>
                    ))
                  ) : (
                    <NoFoundComponent message="" />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- end trail detail images post --> */}

          {/* <!-- start trail post description--> */}
          <div className="trail_description">
            <div className="row">
              <div className="col-lg-9 col-md-8 leftside_detail">
                <div className="trail_post_user">
                  <div className="user_img">
                    <Link to="#">
                      <img src={postDetails?.data?.user?.profile_image} alt={postDetails?.data?.user?.full_name + "-user-profile-pic"} title={postDetails?.data?.user?.full_name} />
                    </Link>
                  </div>
                  <h4 className="d-inline-block text-truncate">
                    <Link to="#">{postDetails?.data?.user?.full_name}</Link>
                  </h4>
                  <ul>
                    <li>
                      {postDetails?.data?.vendor_contact && postDetails?.data?.vendor_contact !== "" ? (
                        isNaN(postDetails?.data?.vendor_contact) ? (
                          <a href={"mailto:" + postDetails?.data?.vendor_contact} className="">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M13.8333 13.8333H2.16667V2.16667H13.8333M13.8333 0.5H2.16667C1.72464 0.5 1.30072 0.675595 0.988155 0.988155C0.675595 1.30072 0.5 1.72464 0.5 2.16667V13.8333C0.5 14.2754 0.675595 14.6993 0.988155 15.0118C1.30072 15.3244 1.72464 15.5 2.16667 15.5H13.8333C14.2754 15.5 14.6993 15.3244 15.0118 15.0118C15.3244 14.6993 15.5 14.2754 15.5 13.8333V2.16667C15.5 1.24167 14.75 0.5 13.8333 0.5ZM11.75 11.5417C11.75 10.2917 9.25 9.66667 8 9.66667C6.75 9.66667 4.25 10.2917 4.25 11.5417V12.1667H11.75M8 8.20833C8.49728 8.20833 8.97419 8.01079 9.32582 7.65916C9.67746 7.30753 9.875 6.83061 9.875 6.33333C9.875 5.83605 9.67746 5.35914 9.32582 5.00751C8.97419 4.65588 8.49728 4.45833 8 4.45833C7.50272 4.45833 7.02581 4.65588 6.67417 5.00751C6.32254 5.35914 6.125 5.83605 6.125 6.33333C6.125 6.83061 6.32254 7.30753 6.67417 7.65916C7.02581 8.01079 7.50272 8.20833 8 8.20833Z"
                                fill="#008B2A"
                              />
                            </svg>
                            {postDetails?.data?.vendor_contact}
                          </a>
                        ) : (
                          <a href={"tel:" + postDetails?.data?.vendor_contact} className="">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M13.8333 13.8333H2.16667V2.16667H13.8333M13.8333 0.5H2.16667C1.72464 0.5 1.30072 0.675595 0.988155 0.988155C0.675595 1.30072 0.5 1.72464 0.5 2.16667V13.8333C0.5 14.2754 0.675595 14.6993 0.988155 15.0118C1.30072 15.3244 1.72464 15.5 2.16667 15.5H13.8333C14.2754 15.5 14.6993 15.3244 15.0118 15.0118C15.3244 14.6993 15.5 14.2754 15.5 13.8333V2.16667C15.5 1.24167 14.75 0.5 13.8333 0.5ZM11.75 11.5417C11.75 10.2917 9.25 9.66667 8 9.66667C6.75 9.66667 4.25 10.2917 4.25 11.5417V12.1667H11.75M8 8.20833C8.49728 8.20833 8.97419 8.01079 9.32582 7.65916C9.67746 7.30753 9.875 6.83061 9.875 6.33333C9.875 5.83605 9.67746 5.35914 9.32582 5.00751C8.97419 4.65588 8.49728 4.45833 8 4.45833C7.50272 4.45833 7.02581 4.65588 6.67417 5.00751C6.32254 5.35914 6.125 5.83605 6.125 6.33333C6.125 6.83061 6.32254 7.30753 6.67417 7.65916C7.02581 8.01079 7.50272 8.20833 8 8.20833Z"
                                fill="#008B2A"
                              />
                            </svg>
                            {postDetails?.data?.vendor_contact}
                          </a>
                        )
                      ) : (
                        ""
                      )}
                    </li>
                    <li>
                      {postDetails?.data?.vendor_website && postDetails?.data?.vendor_website !== "" ? (
                        <a href={postDetails?.data?.vendor_website} className="" target="_blank" rel="noopener noreferrer">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M12.6337 10.6667C12.7003 10.1167 12.7503 9.56666 12.7503 8.99999C12.7503 8.43332 12.7003 7.88332 12.6337 7.33332H15.4503C15.5837 7.86666 15.667 8.42499 15.667 8.99999C15.667 9.57499 15.5837 10.1333 15.4503 10.6667M11.1587 15.3C11.6587 14.375 12.042 13.375 12.3087 12.3333H14.767C13.967 13.7083 12.692 14.775 11.1587 15.3ZM10.9503 10.6667H7.05033C6.96699 10.1167 6.91699 9.56666 6.91699 8.99999C6.91699 8.43332 6.96699 7.87499 7.05033 7.33332H10.9503C11.0253 7.87499 11.0837 8.43332 11.0837 8.99999C11.0837 9.56666 11.0253 10.1167 10.9503 10.6667ZM9.00033 15.6333C8.30866 14.6333 7.75033 13.525 7.40866 12.3333H10.592C10.2503 13.525 9.69199 14.6333 9.00033 15.6333ZM5.66699 5.66666H3.23366C4.02533 4.28332 5.30866 3.21666 6.83366 2.69999C6.33366 3.62499 5.95866 4.62499 5.66699 5.66666ZM3.23366 12.3333H5.66699C5.95866 13.375 6.33366 14.375 6.83366 15.3C5.30866 14.775 4.02533 13.7083 3.23366 12.3333ZM2.55033 10.6667C2.41699 10.1333 2.33366 9.57499 2.33366 8.99999C2.33366 8.42499 2.41699 7.86666 2.55033 7.33332H5.36699C5.30033 7.88332 5.25033 8.43332 5.25033 8.99999C5.25033 9.56666 5.30033 10.1167 5.36699 10.6667M9.00033 2.35832C9.69199 3.35832 10.2503 4.47499 10.592 5.66666H7.40866C7.75033 4.47499 8.30866 3.35832 9.00033 2.35832ZM14.767 5.66666H12.3087C12.042 4.62499 11.6587 3.62499 11.1587 2.69999C12.692 3.22499 13.967 4.28332 14.767 5.66666ZM9.00033 0.666656C4.39199 0.666656 0.666992 4.41666 0.666992 8.99999C0.666992 11.2101 1.54497 13.3297 3.10777 14.8925C3.88159 15.6664 4.80025 16.2802 5.8113 16.699C6.82234 17.1178 7.90598 17.3333 9.00033 17.3333C11.2105 17.3333 13.3301 16.4553 14.8929 14.8925C16.4557 13.3297 17.3337 11.2101 17.3337 8.99999C17.3337 7.90564 17.1181 6.82201 16.6993 5.81096C16.2805 4.79991 15.6667 3.88125 14.8929 3.10743C14.1191 2.33361 13.2004 1.71978 12.1894 1.30099C11.1783 0.882205 10.0947 0.666656 9.00033 0.666656Z"
                              fill="#008B2A"
                            />
                          </svg>
                          {postDetails?.data?.vendor_website}
                        </a>
                      ) : (
                        ""
                      )}
                    </li>
                  </ul>
                </div>
                {postDetails?.data?.updates !== "" ? (
                  <>
                    <hr className="my-4" />

                    <div className="col-md-12 p-0">
                      <div className="alert alert-warning" role="alert">
                        <h4>
                          <span className="float-start">Updates </span>

                          {postDetails?.data?.user_id === user?.id ? (
                            <span className="float-end" onClick={() => dispatch(updatesModal({ modal: true, postId: { id: postDetails?.data?.id, data: postDetails?.data?.updates } }))}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.71667 5.5L10.5 6.28333L2.93333 13.8333H2.16667V13.0667L9.71667 5.5ZM12.7167 0.5C12.5083 0.5 12.2917 0.583333 12.1333 0.741667L10.6083 2.26667L13.7333 5.39167L15.2583 3.86667C15.5833 3.54167 15.5833 3 15.2583 2.69167L13.3083 0.741667C13.1417 0.575 12.9333 0.5 12.7167 0.5ZM9.71667 3.15833L0.5 12.375V15.5H3.625L12.8417 6.28333L9.71667 3.15833Z" fill="#66737f"></path>
                              </svg>
                            </span>
                          ) : (
                            ""
                          )}
                        </h4>{" "}
                        <br />
                        <p className="m-0">{updates}</p>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <hr className="my-4" />
                <div className="col-md-12 p-0">
                  <h4 className="heading_title">About</h4>
                  <p>{postDetails?.data?.description}</p>
                </div>
                {postDetails?.data?.awards && postDetails?.data?.awards?.length ? (
                  <>
                    <hr className="my-4" />
                    <div className="col-md-12 p-0 featuredon">
                      <h4 className="heading_title">Featured on</h4>
                      {postDetails?.data?.awards.map((feature, index) => (
                        <a href={feature?.artical_website} target="_blank" rel="noopener noreferrer" key={"post_awards_in_details" + index}>
                          <h5>
                            <img src={require("../../assets/images/seal.png")} alt="" title="" />
                            <p>{feature?.award_description}</p>
                          </h5>
                        </a>
                      ))}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {postDetails?.data?.trail_posts && postDetails?.data?.trail_posts?.length ? (
                  <>
                    <hr className="my-4" />
                    <div className="col-md-12 p-0">
                      <h4 className="heading_title">Spotted on these Trails</h4>
                      <div className="row spotted_trails">
                        {postDetails?.data?.trail_posts.map((trail, index) => (
                          <div className="col-md-6 col-lg-4" key={"post_suggest_trails_" + index}>
                            {token && token !== undefined && token !== "" ? (
                              <Link to={"/trail-details/" + trail?.slug}>
                                <div className="hz_traillist">
                                  <div className="trail_mainimg">
                                    {/* <img src={require("../../assets/images/spotted_trail.png")} alt="" title="" /> */}
                                    <img src={trail?.trail_img} alt={"spooted-trail-" + trail?.trail_img} title={trail?.trail_img} />
                                  </div>
                                  <h5>{trail?.trail_name}</h5>
                                </div>
                              </Link>
                            ) : (
                              <Link to={"#"} onClick={() => dispatch(logInModal(true))}>
                                <div className="hz_traillist">
                                  <div className="trail_mainimg">
                                    <img src={require("../../assets/images/spotted_trail.png")} alt="" title="" />
                                  </div>
                                  <h5>{trail?.trail_name}</h5>
                                </div>
                              </Link>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="col-lg-3 col-md-4 rightside_detail">
                {postDetails?.data && postDetails?.data?.post_call_to_action && postDetails?.data?.post_call_to_action.length
                  ? postDetails?.data?.post_call_to_action.map((action, index) =>
                    action?.button_name !== "" && action?.website !== "" ? (
                      token && token !== undefined && token !== "" ? (
                        <a href={action?.website} target="_blank" className="btn_save" onClick={(e) => buttonVisited({ post_id: action?.id })}>
                          {action?.button_name}
                        </a>
                      ) : (
                        <a href={"#"} className="btn_save" onClick={() => dispatch(logInModal(true))}>
                          {action?.button_name}
                        </a>
                      )
                    ) : (
                      ""
                    )
                  )
                  : ""}
                {postDetails?.data?.claimed && postDetails?.data?.user_id !== user?.id ? (
                  <Link
                    to="#"
                    className="btn_save btn_outline"
                    onClick={() =>
                      dispatch(
                        cliamBusinessModal({
                          modal: true,
                          postId: postDetails?.data?.id,
                        })
                      )
                    }
                  >
                    Claim the Business
                  </Link>
                ) : (
                  <Link to={`/view-analytics/${postDetails?.data?.slug}`} className="btn_save">
                    View All Analytics
                  </Link>
                )}

                {postAnalytics.length ? (
                  <div className="my-3 p-3" style={{ borderRadius: "20px" }}>
                    <h4 className="heading_title">Trends</h4>
                    {postAnalytics.map((tag, index) => (
                      <div className="d-flex justify-content-between btn_save btn_outline my-3" key={"analyticsTagData_" + index}>
                        <span>{tag.tag}</span>
                        <span>{tag.vote}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {/* <!-- end trail post description--> */}
        </div>
      </>
    );
    // } else {
    //   dispatch(logInModal(true));
    // }
  }
};
